import * as utils from "@twiage/utils";

import type { HTTPError400Handler } from "./types/HTTPError400Handler";
import type { HTTPError401Handler } from "./types/HTTPError401Handler";

const mainRequestErrorHandlerLog = utils.log("MAIN_REQUEST_ERROR_HANDLER");

export const makeMainRequestErrorHandler =
  ({
    httpError400Handler,
    httpError401Handler,
  }: {
    httpError400Handler: HTTPError400Handler;
    httpError401Handler: HTTPError401Handler;
  }) =>
  async ({ error }: { error: unknown }) => {
    if (
      utils.isObject(error) &&
      "response" in error &&
      error.response instanceof Response &&
      "status" in error.response
    ) {
      const { response } = error;

      const { status } = response;

      if (status === 400) {
        await httpError400Handler({ response });

        return;
      }

      if (status === 401) {
        httpError401Handler();

        return;
      }

      mainRequestErrorHandlerLog.warn("unhandled HTTP error", status);
    }

    mainRequestErrorHandlerLog.warn("unhandled unknown error", error);
  };
